import Box from '@mui/material/Box';
import React from 'react';
import { useLocation } from 'react-router';

import config from '../../../config';
import { pickSearchParamsOnly } from '../../../containers/SearchPage/SearchPage.helpers';
import TopbarSearchForm from '../../../forms/TopbarSearchForm/TopbarSearchForm';
import routeConfiguration from '../../../routeConfiguration';
import { FormattedMessage } from '../../../util/reactIntl';
import { createResourceLocatorString } from '../../../util/routes';
import Modal from '../../Modal/Modal';
import { redirectToURLWithoutModalState } from './MobileMenu.util';

// former .modalContainer (--marketplaceModalInMobileBaseStyles + padding 0 + md flex-basis 576px)
const modalContainerSx = (theme) => ({
  ...theme.mixins.marketplaceModalInMobileBaseStyles,
  padding: 0,
  // Merge the mixin's md block with the own md override (both target the same media key);
  // own flexBasis: 576px overrides the mixin's 480px.
  [theme.breakpoints.up('md')]: {
    ...theme.mixins.marketplaceModalInMobileBaseStyles['@media (min-width:900px)'],
    flexBasis: '576px',
  },
});

// former .searchContainer
const searchContainerSx = {
  position: 'relative',
  height: '100%',
  marginTop: '94px',
};

// former .mobileHelp
const mobileHelpSx = (theme) => ({
  color: theme.tokens.matterColorAnti,
  margin: '0 24px',
  // Absolute position to avoid affecting the layout of the autocomplete predictions list.
  position: 'absolute',
  top: '73px',
});

const MobileSearchModal = ({
  searchInURL,
  initialSearchFormValues,
  isMobileSearchOpen,
  onManageDisableScrolling,
  navigate,
  intl,
}) => {
  const location = useLocation();
  const currentSearchParams = pickSearchParamsOnly(
    searchInURL,
    config.custom.filters,
    config.custom.sortConfig,
  );

  const handleMobileSearchClose = () => {
    redirectToURLWithoutModalState(navigate, location, 'mobileSearch');
  };

  const handleSubmit = (values) => {
    const { search, selectedPlace } = values.location;
    const { origin, bounds } = selectedPlace;
    const originMaybe = config.sortSearchByDistance ? { origin } : {};
    const searchParams = {
      ...currentSearchParams,
      ...originMaybe,
      address: search,
      bounds,
    };
    navigate(
      createResourceLocatorString('SearchPage', routeConfiguration(), {}, searchParams, intl.locale),
    );
  };

  return (
    <Modal
      containerSx={modalContainerSx}
      id="TopbarMobileSearch"
      isOpen={isMobileSearchOpen}
      onClose={handleMobileSearchClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Box component="div" sx={searchContainerSx}>
        <TopbarSearchForm
          initialValues={initialSearchFormValues}
          isMobile
          onSubmit={handleSubmit}
        />
        <Box component="p" sx={mobileHelpSx}>
          <FormattedMessage id="Topbar.mobileSearchHelp" />
        </Box>
      </Box>
    </Modal>
  );
};

export default MobileSearchModal;
